var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('kst-input',{attrs:{"field":"Comment","data":_vm.userData,"catalog":_vm.Catalog}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }